import { atom } from 'jotai'

type Input = {
  mode: 'normal' | 'GeneralContractorOrder'
}

const storeValues = atom<Input>({
  mode: 'normal',
})
export const selectSystemModeStore = { state: storeValues } as const
